import loadable from '@loadable/component';

export const OrgDashboardViewGradFairInvitePageLoadable = loadable(
  () => import('./OrgDashboardViewGradFairInvitePage'),
  {
    resolveComponent: (module) => module.OrgDashboardViewGradFairInvitePage,
  },
);
